<!-- <h6>Duration by template</h6> -->
<!---Item for loop in on line 3 to 36 rest is for testing an presentations only-->
<div class="card bg-secondary p-2 pl-1 pr-1 mb-2">
    <div class="row">
        <div class="col-2">
            <img src="../../../../../assets/images/org_blank.png" width="20px" class="rounded-circle">
        </div>
        <div class="col-4 pl-0">
            <p class="mb-0 lh-25 align-middle">Template 1</p>
        </div>
        <div class="col-2">
            <div class="row">
                <span class="material-icons c-save align-middle cursor-default lh-25 ">
                    recommend
                    </span>
                <p class="mb-0 lh-25 c-save font-weight-bold align-middle">2</p>
            </div>
        </div>
        <div class="col-2">
            <div class="row">
                <span class="material-icons c-almost align-middle cursor-default lh-25 ">
                    error
                    </span>
                <p class="mb-0 lh-25 c-almost font-weight-bold align-middle">4</p>
            </div>
        </div>       
        <div class="col-2">
            <div class="row">
                <span class="material-icons c-close align-middle cursor-default lh-25 ">
                    whatshot
                    </span>
                <p class="mb-0 lh-25 font-weight-bold c-close align-middle">6</p>
            </div>
        </div>
    </div>
</div>
<!----Loop item ends here-->
<div class="card bg-secondary p-2 pl-1 pr-1 mb-2">
    <div class="row">
        <div class="col-2">
            <img src="../../../../../assets/images/org_blank.png" width="20px" class="rounded-circle">
        </div>
        <div class="col-4 pl-0">
            <p class="mb-0 lh-25 align-middle">Template 2</p>
        </div>
        <div class="col-2">
            <div class="row">
                <span class="material-icons c-save align-middle cursor-default lh-25 ">
                    recommend
                    </span>
                <p class="mb-0 lh-25 c-save font-weight-bold align-middle">12</p>
            </div>
        </div>
        <div class="col-2">
            <div class="row">
                <span class="material-icons c-almost align-middle cursor-default lh-25 ">
                    error
                    </span>
                <p class="mb-0 lh-25 c-almost font-weight-bold align-middle">5</p>
            </div>
        </div>       
        <div class="col-2">
            <div class="row">
                <span class="material-icons c-close align-middle cursor-default lh-25 ">
                    whatshot
                    </span>
                <p class="mb-0 lh-25 font-weight-bold c-close align-middle">4</p>
            </div>
        </div>
    </div>
</div>
<div class="card bg-secondary p-2 pl-1 pr-1 mb-2">
    <div class="row">
        <div class="col-2">
            <img src="../../../../../assets/images/person_blank.png" width="20px" class="rounded-circle">
        </div>
        <div class="col-4 pl-0">
            <p class="mb-0 lh-25 align-middle">Julie</p>
        </div>
        <div class="col-2">
            <div class="row">
                <span class="material-icons c-save align-middle cursor-default lh-25 ">
                    recommend
                    </span>
                <p class="mb-0 lh-25 c-save font-weight-bold align-middle">9</p>
            </div>
        </div>
        <div class="col-2">
            <div class="row">
                <span class="material-icons c-almost align-middle cursor-default lh-25 ">
                    error
                    </span>
                <p class="mb-0 lh-25 c-almost font-weight-bold align-middle">3</p>
            </div>
        </div>       
        <div class="col-2">
            <div class="row">
                <span class="material-icons c-close align-middle cursor-default lh-25 ">
                    whatshot
                    </span>
                <p class="mb-0 lh-25 font-weight-bold c-close align-middle">3</p>
            </div>
        </div>
    </div>
</div><div class="card bg-secondary p-2 pl-1 pr-1 mb-2">
    <div class="row">
        <div class="col-2">
            <img src="../../../../../assets/images/person_blank.png" width="20px" class="rounded-circle">
        </div>
        <div class="col-4 pl-0">
            <p class="mb-0 lh-25 align-middle">Andre</p>
        </div>
        <div class="col-2">
            <div class="row">
                <span class="material-icons c-save align-middle cursor-default lh-25 ">
                    recommend
                    </span>
                <p class="mb-0 lh-25 c-save font-weight-bold align-middle">8</p>
            </div>
        </div>
        <div class="col-2">
            <div class="row">
                <span class="material-icons c-almost align-middle cursor-default lh-25 ">
                    error
                    </span>
                <p class="mb-0 lh-25 c-almost font-weight-bold align-middle">4</p>
            </div>
        </div>       
        <div class="col-2">
            <div class="row">
                <span class="material-icons c-close align-middle cursor-default lh-25 ">
                    whatshot
                    </span>
                <p class="mb-0 lh-25 font-weight-bold c-close align-middle">2</p>
            </div>
        </div>
    </div>
</div>
<div class="card bg-secondary p-2 pl-1 pr-1 mb-2">
    <div class="row">
        <div class="col-2">
            <img src="../../../../../assets/images/person_blank.png" width="20px" class="rounded-circle">
        </div>
        <div class="col-4 pl-0">
            <p class="mb-0 lh-25 align-middle">Alex</p>
        </div>
        <div class="col-2">
            <div class="row">
                <span class="material-icons c-save align-middle cursor-default lh-25 ">
                    recommend
                    </span>
                <p class="mb-0 lh-25 c-save font-weight-bold align-middle">5</p>
            </div>
        </div>
        <div class="col-2">
            <div class="row">
                <span class="material-icons c-almost align-middle cursor-default lh-25 ">
                    error
                    </span>
                <p class="mb-0 lh-25 c-almost font-weight-bold align-middle">2</p>
            </div>
        </div>       
        <div class="col-2">
            <div class="row">
                <span class="material-icons c-close align-middle cursor-default lh-25 ">
                    whatshot
                    </span>
                <p class="mb-0 lh-25 font-weight-bold c-close align-middle">1</p>
            </div>
        </div>
    </div>
</div>
<div class="card bg-secondary p-2 pl-1 pr-1 mb-2">
    <div class="row">
        <div class="col-2">
            <img src="../../../../../assets/images/person_blank.png" width="20px" class="rounded-circle">
        </div>
        <div class="col-4 pl-0">
            <p class="mb-0 lh-25 align-middle">Victor</p>
        </div>
        <div class="col-2">
            <div class="row">
                <span class="material-icons c-save align-middle cursor-default lh-25 ">
                    recommend
                    </span>
                <p class="mb-0 lh-25 c-save font-weight-bold align-middle">10</p>
            </div>
        </div>
        <div class="col-2">
            <div class="row">
                <span class="material-icons c-almost align-middle cursor-default lh-25 ">
                    error
                    </span>
                <p class="mb-0 lh-25 c-almost font-weight-bold align-middle">1</p>
            </div>
        </div>       
        <div class="col-2">
            <div class="row">
                <span class="material-icons c-close align-middle cursor-default lh-25 ">
                    whatshot
                    </span>
                <p class="mb-0 lh-25 font-weight-bold c-close align-middle">0</p>
            </div>
        </div>
    </div>
</div>